import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./pages/App";
import { BrowserRouter } from "react-router-dom";


console.log(`env.GSK_API_HOST: ${process.env.GSK_API_HOST}`);
console.log(`env.GSK_API_HOST_SOURCE: ${process.env.GSK_API_HOST_SOURCE}`);
console.log(`env.NODE_ENV: ${process.env.NODE_ENV}`);

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById("App")
);
